module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Mary-Shelley.1934052.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Mary-Shelley.jpg
// module id = w/GV
// module chunks = 0